import React, { useEffect } from 'react';
import {Link} from 'react-router-dom'
import {FaAward, FaUsers, FaFolderOpen} from 'react-icons/fa'
import avatarAbout from '../../assets/img/avatarAbout.jpg'
import AOS from 'aos'
import 'aos/dist/aos.css';

import './about.css'

const About = () => {

  let year = new Date().getFullYear()
  const workYear = () => {
    return year - 2020
  }
  useEffect(() => {
    AOS.init({duration: 800})
  }, []);


  return (
    <section id='about'>
      <h4 data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-delay="100">Get to Know</h4>
      <h2 data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-delay="200">About Me</h2>
      <div className="container about-container">
        <div className="about-content">
          <div className="about-cards">
            <a href="#experince" className='about-card' data-aos="fade-right" data-aos-delay="800">
              <article>
                <FaAward className='about-icon'/>
                <h5>Experience</h5>
                <small>{workYear()}+ Years Working</small>
              </article>
            </a>
            <article className='about-card' data-aos="fade-right" data-aos-delay="700">
              <FaUsers className='about-icon'/>
              <h5>Clients</h5>
              <small>25+ Worldwide</small>
            </article>
            <a href="#projects" className='about-card' data-aos="fade-right" data-aos-delay="600">
              <article >
                <FaFolderOpen className='about-icon'/>
                <h5>Projects</h5>
                <small>30+ Completed Projects</small>
              </article>
            </a>  
          </div>
          <p data-aos="fade-right" data-aos-delay="900">
            Adaptable and passionate Developer, with <b>2+ years of experience</b> developing websites with <b>HTML5, CSS3, JS, Sass, Bootstrap & React</b>, designing and developing projects such as <b>SPA, operational platformers, and full static websites</b>, making use of <b>APIs and Adobe Xd</b>.<br/>Former project manager & administrator in a multinational company.
          </p>
          <Link to="/contact" className='btn btn-primary' data-aos="fade-right" data-aos-delay="1000">Let's Talk</Link>
        </div>
        <div className="about-me-avatar" data-aos="fade-right" data-aos-delay="300">
          <img src={avatarAbout} alt="Mussagy Remane" />
        </div>
      </div>
    </section>
  );
}

export default About;
